export default interface IRequestResponse {
	error: string;
	success: string;
	loading: boolean;
}

export const InitialRquestResponseState: IRequestResponse = {
	error: "",
	success: "",
	loading: false,
};
